import React from "react";
import { useTranslation } from "react-i18next";
import "./TestimonialCard.css";
import Star from "assets/icone/Star";
import StarMobile from "assets/icone/StarMobile";

interface TestimonialCardProps {
  name: string;
  text: string;
  imageSrc: string;
  imageAlt: string;
  rating: number; // מספר כוכבים (1-5)
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  name,
  text,
  imageSrc,
  imageAlt,
  rating,
}) => {
  const { i18n } = useTranslation();
  // יצירת מערך של כוכבים
  const renderStars = () => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={`star ${i < rating ? "filled" : "empty"}`}>
          <Star className="star-desktop" />
          <StarMobile className="star-mobile" />
        </span>
      );
    }
    return stars;
  };

  return (
    <div className="testimonial-card" data-language={i18n.language}>
      <div className="testimonial-header">
        <div className="testimonial-profile">
          <img
            src={imageSrc}
            alt={imageAlt}
            className="profile-image"
            onError={(e) => {
              e.currentTarget.src = "/images/image-error.jpg";
            }}
          />
        </div>
        <div className="testimonial-info">
          <h3 className="testimonial-name">{name}</h3>
          <div className="testimonial-stars">{renderStars()}</div>
        </div>
      </div>
      <p className="testimonial-text">{text}</p>
    </div>
  );
};

export default TestimonialCard;
